import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";

declare var eController: any; /* ECON APP */
declare var gmoAuthOrderDecision: any; /* GMO */

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  public econapps: any;
  public $: any;
  public moment: any;

  constructor(
    public httpClient: HttpClient,
    public appConfig: AppConfig,
    public commonService: CommonService
  ) {
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
  }

  /* ECON BELOW */
  /* Not Used */
  // initEcon(data: any = {}, callback: any = null) {
  //     let self = this;
  //     self.econapps = new eController.EconSconeCardPay(`${data.sessionToken}`, `${data.requestID}`);
  //     self.econapps.fetchEntryResources(function(result: any) {
  //         if (result.status == 1){
  //             callback({status: "success"});
  //         } else {
  //             callback({status: "fail"});
  //         }
  //     });
  // }

  // econSaveEntries(params: any = {}, callback: any = null) {
  //     let self = this;
  //     self.econapps.saveEntries(params.cardNo, params.cardOwner, params.expDate, "00", params.cvv2Code, params.usedCardFlg, function (result: any) {
  //         if (result.status == 1) {
  //             let saveData = self.econapps.getSaveEntries();

  //             /* REDIRECT */
  //             /* self.econapps.goPayment(function (result: any) {
  //             }); */

  //             callback({status: "success"});
  //         } else {
  //             callback({status: "fail", data: result});
  //         }
  //     });
  // }

  // async getEconTokenData(data: any) {
  //   let params = {
  //     url: this.appConfig.busAPIBaseURL + "reserve/buildEconTokenData",
  //     options: {
  //       headers: this.commonService.getHTTPBusHeader(),
  //       params: {
  //           sei: data.sei,
  //           mei: data.mei,
  //           tel: data.tel,
  //           email: data.email,
  //           returnURL: data.returnURL,
  //       },
  //     }
  //   }

  //   let returnData = await this.commonService.sendHTTPGet(params);
  //   return returnData;
  // }
  /* END */

  /* GMO */
  gmoInit() {
    if (typeof gmoAuthOrderDecision != "function") {
      /* js for GMOSMS authentication */
      this.$("head").append(
        `<script src="https://testshop.gmo-ab.com/js/gmoSmsCertification.js?${this.moment().format(
          "YYYYMMDDHH"
        )}" type="text/javascript"><\/script>`
      );
    }
  }

  async gmoCreateTransaction(inputData: any, cartData: any) {
    /*
            :: CHECKSUM ::
            - INPUT: ab008993-00ab00899300|GNT-1111-2222-0012|09076465248|530-0015|10000|1|1991/01/03|2020/02/03|5|15000|1234567890
            - OUTPUT: 8/9oaa+HeWQ3+brm+vAHjcYbQZ/51wugO/U5/bxSTBg=
        */
    let transactionID = `lom-${this.moment().format(
      "YYYY-MM-DD"
    )}-${this.moment().valueOf()}`;
    let checksumData = await this.gmoChecksum({
      checksum: `${transactionID}|${inputData.postpay_tel}|${
        inputData.postpay_zipcode
      }|${inputData.totalAmount}|${inputData.c_sex}|${this.moment(
        inputData.c_birthday
      ).format("YYYY/MM/DD")}||||${inputData.c_mail}`,
    });

    /* ITEM */
    let gmoItemName: any = [];
    for (let item of cartData) {
      gmoItemName.push(item.plan.bus_code);
    }
    gmoItemName = `高速バス乗車代金 (${gmoItemName.join(", ")})`;

    let htmlForm = `
            <input type="text" class="gmoAuthenticationId" value="${
              this.appConfig.payment.gmo.authID
            }" >
            <input type="text" class="gmoShopCode" value="${
              this.appConfig.payment.gmo.merchantCode
            }" >
            <input type="text" class="gmoSmsPassword" value="${
              this.appConfig.payment.gmo.smsPassword
            }" >

            <!-- SHOP INFO -->
            <input type="text" class="gmoShopTransactionId" value="${transactionID}" >
            <input type="text" class="gmoShopOrderDate" value="${this.moment().format(
              "YYYY/MM/DD"
            )}" >
            <input type="text" class="gmoFullName" value="${inputData.c_sei} ${
      inputData.c_mei
    }" >
            <input type="text" class="gmoFullKanaName" value="" >
            <input type="text" class="gmoZipCode" value="${
              inputData.postpay_zipcode
            }" >
            <input type="text" class="gmoAddress" value="${
              inputData.postpay_prefecture
            } ${inputData.postpay_city} ${inputData.postpay_street} ${
      inputData.postpay_apartment
    }" >
            <input type="text" class="gmoCompanyName" value="" >
            <input type="text" class="gmoDepartmentName" value="" >
            <input type="text" class="gmoTel1" value="${
              inputData.postpay_tel
            }" >
            <input type="text" class="gmoTel2" value="" >
            <input type="text" class="gmoEmail1" value="${inputData.c_mail}" >
            <input type="text" class="gmoEmail2" value="" >

            <!-- TOTAL AMOUNT (ALL) -->
            <input type="text" class="gmoBilledAmount" value="${
              inputData.totalAmount
            }" >
            <input type="text" class="gmoExtend1" value="" >

            <!-- 2: Separate packages, 3: Same package -->
            <input type="text" class="gmoPaymentType" value="2" >
            <input type="text" class="gmoSex" value="${inputData.c_sex}" >
            <input type="text" class="gmoBirthday" value="${this.moment(
              inputData.c_birthday
            ).format("YYYY/MM/DD")}" >
            <input type="text" class="gmoMemberRegistDate" value="" >
            <input type="text" class="gmoBuyCount" value="" >
            <input type="text" class="gmoBuyAmoutTotal" value="" >
            <input type="text" class="gmoMemberId" value="${inputData.c_mail}" >
            <input type="text" class="gmoFullNameDelivery" value="${
              inputData.c_sei
            } ${inputData.c_mei}" >
            <input type="text" class="gmoFullKanaNameDelivery" value="" >
            <input type="text" class="gmoZipCodeDelivery" value="${
              inputData.postpay_zipcode
            }" >
            <input type="text" class="gmoAddressDelivery" value="${
              inputData.postpay_prefecture
            } ${inputData.postpay_city} ${inputData.postpay_street} ${
      inputData.postpay_apartment
    }" >
            <input type="text" class="gmoCompanyNameDelivery" value="" >
            <input type="text" class="gmoDepartmentNameDelivery" value="" >
            <input type="text" class="gmoTelDelivery" value="${
              inputData.postpay_tel
            }" >

            <!-- PRODUCTS -->
            <input type="text" class="gmoDetailNameDetail" value="${gmoItemName}" >
            <input type="text" class="gmoDetailPriceDetail" value="${
              inputData.totalAmount
            }" >
            <input type="text" class="gmoDetailQuantityDetail" value="1" >
            <input type="text" class="gmoGmoExtend2Detail" value="" >
            <input type="text" class="gmoGmoExtend3Detail" value="" >
            <input type="text" class="gmoGmoExtend4Detail" value="" >
            <input type="text" class="gmoDetailBrand" value="Busbookmark" >
            <input type="text" class="gmoDetailCategory" value="Bus Ticket" >

            <!-- CHECKSUM -->
            <input type="text" class="gmoChksumReq" value="${checksumData}" >

            <!-- Device information -->
            <input type="hidden" id="fraudbuster" name="fraudbuster" class="gmoDeviceInfo" >
            <script type="text/javascript" src="https://fraud-buster.appspot.com/js/fraudbuster.js"><\/script>
       `;

    this.$("#gmoFormData").empty().html(htmlForm);
  }

  async gmoChecksum(queryString: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/gmoChecksum",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: queryString,
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);
    if (returnData.status == "success") {
      return returnData.data;
    }

    return null;
  }
  /* END */

  /* Veritrans */
  async getVeritransToken(postData: any) {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };

    /* GET BUS SETTINGS */
    let busSettings = this.commonService.getData(
      this.commonService.appConfig.site.settingSessionName
    );

    if (postData) {
      postData.token_api_key = busSettings.veritrans.token_api_key;
    }

    let params = {
      url: busSettings.veritrans.token_api_url,
      data: postData,
      options: {
        headers: header,
      },
    };

    return await this.httpClient
      .post(params.url, params.data, params.options)
      .toPromise()
      .then(function (res) {
        return res;
      })
      .catch(function (res) {
        return res.error;
      });
  }
}
